enum PotType {
  DefinedBenefit,
  Pension,
  Savings
}

export default PotType;
